import request from "@/utils/request";

export function palmDescriptionGetAllForDropdown(params) {
    return request({
        url: "/api/services/app/PalmDescription/GetAllForDropdown",
        method: "GET",
        params
    });
}

export function palmDescriptionGet(params) {
    return request({
        url: "/api/services/app/PalmDescription/Get",
        method: "GET",
        params
    });
}

export function palmDescriptionCreate(data) {
    return request({
        url: "/api/services/app/PalmDescription/Create",
        method: "POST",
        data
    });
}

export function palmDescriptionUpdate(data) {
    return request({
        url: "/api/services/app/PalmDescription/Update",
        method: "PUT",
        data
    });
}

export function palmDescriptionDelete(params) {
    return request({
        url: "/api/services/app/PalmDescription/Delete",
        method: "DELETE",
        params
    });
}



// WEBPACK FOOTER //
// ./src/api/palm_description.js